import React from 'react';
import classes from './CheckBox.module.css';

type Props = {
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
  label?: string;
};

const CheckBox: React.FC<Props> = ({ isChecked, onChange, label }) => {
  return (
    <div className={classes.container}>
      <input
        checked={isChecked}
        type={'checkbox'}
        className={classes.input}
        onChange={(event) => onChange(event.target.checked)}
      />
      {label && <label className={classes.label}>{label}</label>}
    </div>
  );
};

export { CheckBox };
